<template>
    <v-container class="py-16">
        <v-row justify="center" class="pt-6">
            <v-col
                cols="8"
                md="6"
                class="d-flex flex-column justify-center align-center"
            >
                <v-card flat>
                    <v-card-title class="text-h5 indigo--text text--darken-4 justify-center font-weight-medium">
                        We aim with pride to achieve perfect safety.
                    </v-card-title>
                    <v-card-text class="text-center pt-3 grey--text text--darken-4">
                        <p class="text-body-1">
                            “Safety First, Always” includes the prevention of all work related 
                            incidents including disasters, industrial hygiene and traffic accidents.
                        </p>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="8"
                md="6"
                class="d-flex justify-center"
            >
                <v-img
                    src="@/assets/safety_fundamentals.png"
                    max-width="450"
                    alt="Prospira's saftey fundamentals condensend into a circular graphic"
                ></v-img>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'SafetyPolicy'
}
</script>

<style scoped>
    .title {
        border-radius: 100%;
        border: 3px solid #00B1C3;
        height: 150px;
        width: 150px;
    }
</style>